import React from "react";
import Modal from "react-modal";
import { customModalStyles } from "_shared/components/Modal/ModalStyles";
import { API, graphqlOperation } from "aws-amplify";
import Loading from "_shared/components/Loading/Loading";

Modal.setAppElement("#root");

export default function RequestTickerAlert(props) {
  const [confirmation, setConfirmation] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  return (
    <Modal
      isOpen={props.modalOpen}
      onRequestClose={() => {
        props.setModalOpen(false);
      }}
      style={customModalStyles}
    >
      {loading ? (
        <Loading variant="modal" />
      ) : !confirmation ? (
        <div className="longbow-modal">
          <div
            className="longbow-modal-content"
            style={{ height: "auto", padding: "30px 20px" }}
          >
            <i
              onClick={async () => {
                props.setModalOpen(false);
              }}
              className="fas fa-times"
              style={{
                position: "absolute",
                right: 15,
                top: 15,
                color: "#75ce41",
                cursor: "pointer",
              }}
            />
            <i
              className={"justify-center fas fa-plus-circle"}
              style={{
                color: "#75ce41",
                fontSize: 50,
              }}
            />
            <div
              className="longbow-tabs-text"
              style={{ textAlign: "center", fontSize: 25, fontWeight: "bold" }}
            >
              {props.name} ({props.ticker})
            </div>

            <div
              className="add-tab-small-text"
              style={{
                textAlign: "center",
                fontSize: 20,
                color: "white",
                height: 100,
              }}
            >
              We currently do not have this ticker available. We accept request
              for inclusion into our universe from users. Click below to make
              the request.
            </div>
            <div className="longbow-tab-buttons">
              <div
                className="longbow-button-save"
                style={{
                  width: "83%",
                  margin: "auto",
                  marginTop: 50,
                  marginBotton: 30,
                }}
                onClick={async () => {
                  setLoading(true);

                  const response = await API.graphql(
                    graphqlOperation(`
                      mutation { insert_request_tickers_one(object: {ticker: "${props.ticker}"}) {
                          id
                        }
                      }
                      `),
                  );
                  if (response.data.insert_request_tickers_one.id)
                    await API.post("auth", "/cognito/sendRequestedTickerMail", {
                      body: {
                        ticker: `${props.name} (${props.ticker})`,
                      },
                    });
                  setLoading(false);
                  setConfirmation(true);
                }}
              >
                Confirm
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="help-modal">
          <div className="modal-header">
            <i
              onClick={() => {
                setConfirmation(false);
                props.setModalOpen(false);
              }}
              className="fas fa-times"
            ></i>
          </div>
          <div className="modal-content-thank-you">
            <i className="header-icon-thank-you justify-center envelope-icon far fa-envelope"></i>
            <div className="header-text-thank-you">Message received.</div>
            <div className="body-text-thank-you">
              We've received your message and have sent you a confirmation email
              to <div className="email">{props.email}</div>. Someone from our
              team will follow up with you within the next 48 hours.
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
}
